/* RAPT conversion: quick add, free shipping bar, cart Afterpay, Complete the look */
(function(){
  if (window.__raptConv) return; window.__raptConv = true;
  var FREE = 16000;
  var lastUpsellFor = null;

  function money(c){ return '$' + (c/100).toFixed(2); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]; }); }

  function openCart(item, btn){
    /* Tell the theme and any cart app that something was added (never leave the page) */
    if (document.getElementById('CartDrawer')) {
      /* Theme slide-out cart: rebuild it and slide it open */
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
      return;
    }
    /* Fallback: open the cart the same way a shopper does, via the header cart icon */
    setTimeout(function(){
      var icon = document.querySelector('.site-header a.js-drawer-open-cart, .site-header a[href$="/cart"], header a[href$="/cart"], a.js-drawer-open-cart');
      if (icon) icon.click();
    }, 250);
  }

  function addToCart(id, btn){
    var label = btn ? btn.innerHTML : '';
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function(r){ return r.json().then(function(d){ return { ok: r.ok, d: d }; }); })
    .then(function(res){
      if (btn) btn.classList.remove('is-loading');
      if (!res.ok) {
        if (btn) { btn.textContent = 'Sold out'; btn.disabled = true; }
        return;
      }
      var item = res.d.items ? res.d.items[0] : res.d;
      if (btn) {
        btn.classList.add('is-added'); btn.innerHTML = 'Added';
        setTimeout(function(){ btn.classList.remove('is-added'); btn.innerHTML = label; }, 1800);
      }
      openCart(item, btn);
      setTimeout(refresh, 400);
    }).catch(function(){ if (btn) btn.classList.remove('is-loading'); });
  }

  window.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('[data-rapt-qa-add],[data-rapt-qa-toggle],.rapt-desc-toggle,[data-rapt-disc-apply],[data-rapt-disc-remove]') : null;
    if (!t) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (t.hasAttribute('data-rapt-disc-apply')) { applyCode(t.closest('[data-rapt-disc]')); return; }
    if (t.hasAttribute('data-rapt-disc-remove')) { removeCode(t.getAttribute('data-rapt-disc-remove')); return; }
    if (t.hasAttribute('data-rapt-qa-add')) { if (!t.disabled) addToCart(t.getAttribute('data-variant'), t); return; }
    if (t.hasAttribute('data-rapt-qa-toggle')) {
      var box = t.parentNode.querySelector('.rapt-qa__sizes');
      if (!box) return;
      var open = box.hasAttribute('hidden');
      if (open) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (t.classList.contains('rapt-desc-toggle')) {
      var d = t.previousElementSibling; if (!d) return;
      var isOpen = d.classList.toggle('is-open');
      t.textContent = isOpen ? 'Show less' : 'Read more';
    }
  }, true);

  function setBars(cart){
    var total = cart.total_price;
    [].forEach.call(document.querySelectorAll('[data-rapt-ship]'), function(el){
      if (!cart.item_count) { el.setAttribute('hidden', ''); return; }
      el.removeAttribute('hidden');
      var msg = el.querySelector('[data-rapt-ship-msg]');
      var fill = el.querySelector('[data-rapt-ship-fill]');
      if (total >= FREE) msg.innerHTML = 'You’ve unlocked <strong>FREE NZ shipping!</strong>';
      else msg.innerHTML = 'You’re <strong>' + money(FREE - total) + '</strong> away from <strong>FREE NZ shipping</strong>';
      if (fill) fill.style.width = Math.min(100, Math.round(total * 100 / FREE)) + '%';
    });
    [].forEach.call(document.querySelectorAll('[data-rapt-cart-ap]'), function(el){ el.textContent = money(Math.floor(total / 4)); });
    discounts(cart);
    upsell(cart);
  }

  function discountTitles(cart){
    var seen = {}, out = [];
    function add(t){ if (t && !seen[t]) { seen[t] = 1; out.push(t); } }
    (cart.cart_level_discount_applications || []).forEach(function(d){ add(d.title); });
    (cart.items || []).forEach(function(i){ (i.line_level_discount_allocations || []).forEach(function(a){ add(a.discount_application && a.discount_application.title); }); });
    return out;
  }

  function discounts(cart){
    var saved = cart.total_discount || 0;
    var titles = discountTitles(cart);
    var codes = (cart.discount_codes || []).filter(function(c){ return c.applicable; });
    [].forEach.call(document.querySelectorAll('[data-rapt-disc]'), function(box){
      var s = box.querySelector('[data-rapt-disc-saved]');
      if (s) {
        if (saved > 0) {
          s.innerHTML = (titles.length ? '<strong>' + esc(titles.join(', ')) + '</strong> applied · ' : '') + 'You’re saving <strong>' + money(saved) + '</strong>';
          s.removeAttribute('hidden');
        } else { s.setAttribute('hidden', ''); s.innerHTML = ''; }
      }
      var c = box.querySelector('[data-rapt-disc-codes]');
      if (c) c.innerHTML = codes.map(function(x){
        return '<span class="rapt-disc__chip">' + esc(x.code) + '<button type="button" class="rapt-disc__remove" data-rapt-disc-remove="' + esc(x.code) + '" aria-label="Remove code ' + esc(x.code) + '">×</button></span>';
      }).join('');
    });
  }

  function setDiscountCodes(list){
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: list.join(',') })
    }).then(function(r){ return r.json(); });
  }

  function rebuildThemeCart(){
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    if (!document.getElementById('CartDrawer') && document.getElementById('CartPageForm')) { setTimeout(function(){ window.location.reload(); }, 600); }
  }

  function applyCode(box){
    var input = box.querySelector('[data-rapt-disc-input]');
    var btn = box.querySelector('[data-rapt-disc-apply]');
    var msg = box.querySelector('[data-rapt-disc-msg]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { input.focus(); return; }
    btn.classList.add('is-loading'); msg.className = 'rapt-disc__msg'; msg.textContent = '';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); })
      .then(function(cur){
        var keep = (cur.discount_codes || []).filter(function(c){ return c.applicable && c.code.toUpperCase() !== code; }).map(function(c){ return c.code; });
        return setDiscountCodes(keep.concat([code])).then(function(cart){ return { cart: cart, keep: keep }; });
      })
      .then(function(res){
        btn.classList.remove('is-loading');
        var hit = (res.cart.discount_codes || []).filter(function(c){ return c.code.toUpperCase() === code; })[0];
        if (hit && hit.applicable) {
          msg.className = 'rapt-disc__msg is-ok'; msg.textContent = 'Code ' + code + ' applied.';
          input.value = '';
          setBars(res.cart); rebuildThemeCart();
        } else {
          msg.className = 'rapt-disc__msg is-error';
          msg.textContent = 'Sorry, ' + code + ' isn’t valid for the items in your cart.';
          setDiscountCodes(res.keep).then(function(c){ setBars(c); });
        }
      })
      .catch(function(){
        btn.classList.remove('is-loading');
        msg.className = 'rapt-disc__msg is-error'; msg.textContent = 'Something went wrong, please try again or enter the code at checkout.';
      });
  }

  function removeCode(code){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); })
      .then(function(cur){
        var keep = (cur.discount_codes || []).filter(function(c){ return c.applicable && c.code !== code; }).map(function(c){ return c.code; });
        return setDiscountCodes(keep);
      })
      .then(function(cart){ setBars(cart); rebuildThemeCart(); });
  }

  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var input = e.target.closest ? e.target.closest('[data-rapt-disc-input]') : null;
    if (!input) return;
    e.preventDefault(); applyCode(input.closest('[data-rapt-disc]'));
  }, true);

  function upsell(cart){
    var box = document.querySelector('[data-rapt-upsell]');
    if (!box) return;
    if (!cart.item_count) { box.setAttribute('hidden', ''); lastUpsellFor = null; return; }
    var pid = cart.items[0].product_id;
    var inCart = {}; cart.items.forEach(function(i){ inCart[i.product_id] = 1; });
    if (lastUpsellFor === pid) {
      [].forEach.call(box.querySelectorAll('[data-pid]'), function(n){ n.style.display = inCart[n.getAttribute('data-pid')] ? 'none' : ''; });
      return;
    }
    lastUpsellFor = pid;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var list = (d.products || []).filter(function(p){ return p.available && !inCart[p.id]; }).slice(0, 3);
        if (!list.length) { box.setAttribute('hidden', ''); return; }
        box.querySelector('.rapt-upsell__list').innerHTML = list.map(function(p){
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
          var single = p.variants.length === 1;
          var v = p.variants.filter(function(x){ return x.available; })[0] || p.variants[0];
          var btn = single
            ? '<button type="button" class="rapt-qa__btn" data-rapt-qa-add data-variant="' + v.id + '">+ Add</button>'
            : '<a class="rapt-qa__btn" href="' + esc(p.url) + '">View</a>';
          return '<div class="rapt-upsell__item" data-pid="' + p.id + '">' +
            '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
            '<a class="rapt-upsell__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="rapt-upsell__price">' + money(p.price) + '</span>' +
            '<div class="rapt-qa">' + btn + '</div></div>';
        }).join('');
        box.removeAttribute('hidden');
      }).catch(function(){ box.setAttribute('hidden', ''); });
  }

  var busy = false;
  function refresh(){
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ busy = false; setBars(c); })
      .catch(function(){ busy = false; });
  }

  function clampDescriptions(){
    [].forEach.call(document.querySelectorAll('.collection__description'), function(d){
      if (d.classList.contains('rapt-clamp')) return;
      if (!(d.textContent || '').trim()) return;
      d.classList.add('rapt-clamp');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'rapt-desc-toggle'; b.textContent = 'Read more';
      d.parentNode.insertBefore(b, d.nextSibling);
    });
  }

  function shine(){
    [].forEach.call(document.querySelectorAll('#CartDrawer .cart__checkout'), function(b){
      b.classList.remove('rapt-shine'); void b.offsetWidth; b.classList.add('rapt-shine');
      setTimeout(function(){ b.classList.remove('rapt-shine'); }, 1700);
    });
  }

  function watchDrawer(){
    var d = document.getElementById('CartDrawer'); if (!d) return;
    var wasOpen = d.classList.contains('drawer--is-open');
    new MutationObserver(function(){
      var isOpen = d.classList.contains('drawer--is-open');
      if (isOpen && !wasOpen) setTimeout(shine, 300);
      wasOpen = isOpen;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('ajaxProduct:added', function(){ setTimeout(shine, 700); });
  }

  /* Product pages: hide the Klaviyo reviews area when the product has no reviews yet */
  function hideEmptyReviews(){
    var widget = document.querySelector('[id*=klaviyo_reviews_product_reviews]');
    var stars = document.querySelector('[id*=klaviyo_reviews_average_rating]');
    if (!widget && !stars) return;
    var empty = /no reviews yet|be the first to (write|review)|(^|[^0-9])0 reviews/i;
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      var hasReviews = widget && widget.querySelector('.kl_reviews__review_item');
      if (hasReviews) { clearInterval(iv); return; }
      var wText = widget ? (widget.textContent || '') : '';
      if (widget && empty.test(wText)) {
        var sec = widget.closest('.shopify-section') || widget;
        sec.classList.add('rapt-no-reviews');
        if (stars && (empty.test(stars.textContent || '') || !(stars.textContent || '').trim())) stars.classList.add('rapt-no-reviews');
        clearInterval(iv); return;
      }
      if (tries > 30) clearInterval(iv);
    }, 500);
  }

  function init(){
    clampDescriptions();
    watchDrawer();
    hideEmptyReviews();
    if (document.querySelector('[data-rapt-ship],[data-rapt-upsell],[data-rapt-disc]')) refresh();
    [].forEach.call(document.querySelectorAll('[data-subtotal]'), function(el){
      new MutationObserver(function(){ refresh(); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
    ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function(ev){
      document.addEventListener(ev, function(){ setTimeout(refresh, 500); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
